import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { HowToPlayPage } from "@/components/HowToPlayPage";
import { cash4lifeHowToPlayData } from "@/data/how-to-play-cash4life";
import { buildFaqJsonLd } from "@/lib/faq-jsonld";

export const Route = createFileRoute("/cash4life/how-to-play")({
  head: () => buildSeo({
    title: "How to Play Cash4Life: Rules, Prizes & Odds | USA Lottery Club",
    description: cash4lifeHowToPlayData.meta.description,
    path: "/cash4life/how-to-play",
    type: "article",
    jsonLd: buildFaqJsonLd(cash4lifeHowToPlayData),
  }),
  component: () => <HowToPlayPage {...cash4lifeHowToPlayData} />,
});